// extracted by mini-css-extract-plugin
export default {"container":"gP-z","topReviewHeading":"hP-z","criticalReview":"iP-z","favorableReview":"jP-z","vsSeparator":"kP-z"};